var link_viewer_default = {
  "fontElementMap": "DHBw3",
  "link": "Dm-aG",
  "linkInEditor": "_9S125",
  "linkInViewer": "TZlMA",
  "toolbarUrlContainer": "rTdDa",
  "toolbarUrl": "o8fs0",
  "toolbarUrlAnchor": "_1VHPL"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
